import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";

export default class extends ApplicationController {

    static targets = ["hm0_output"];

    connect() {
        console.log("Entretien JS en cours ...");
        super.connect();

        var self = this;

        console.log("current app: " + this.current_app)
        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            //this.show_edition_multiple();
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });
        }
    }

    get current_app() {
        return this.data.get("app");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }

}
